import React from 'react'
import { Box, Link } from 'front-end/src/components'
import { getUrlForReceptionist } from 'front-end/src/pages/auth/AuthHelpers'
import { staticLinks } from 'shared/linkBuilder'
import { Trans } from '@lingui/macro'

export const SignToDifferentTeamLink = () => (
  <Box mt="32px" textAlign="center">
    <Link href={`${getUrlForReceptionist()}${staticLinks.selectSubdomain}`}>
      <Trans>Sign in to a different team</Trans>
    </Link>
  </Box>
)
